import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Nullable } from '@ps/utils';
import type {
  DateRangeFilterParams,
  SearchPSIDsParams,
  UploadPsidFileResult,
} from '@ps/survey-utils';
import { formatDate } from '@ps/survey-utils';

import { PsidApi } from '../../api/psid/psid.api';

@Injectable({ providedIn: 'root' })
export class PsidService {
  private readonly _api = inject(PsidApi);

  public getAll(
    dateRange: Nullable<DateRangeFilterParams>,
    surveyIds: number[],
  ): Observable<SearchPSIDsParams> {
    return this._api.getAll(
      formatDate(dateRange?.start),
      formatDate(dateRange?.end),
      surveyIds,
    );
  }

  public getCounts(
    isExclusion: boolean,
    surveyIds: number[],
    groupingStatuses: number[],
  ): Observable<number> {
    return this._api.getCounts(isExclusion, surveyIds, groupingStatuses);
  }

  public uploadPsidFile(
    surveyId: number,
    file: File,
  ): Observable<UploadPsidFileResult> {
    return this._api.uploadPsidFile(surveyId, file);
  }

  public clearUploadedPsids(surveyId: number): Observable<void> {
    return this._api.clearUploadedPsids(surveyId);
  }
}
